import React from "react";
import { Box, Flex, Text } from "theme-ui";
import glPlusWhite from "./images/GLplus_white_gradient.svg";
import roofHubLogoWhite from "./images/roof-hub-logo-white.png";
import goodLeapWordmarkWhite from "../../images/goodleap-white-orange.svg";

const rh = {
  maroon: "#762123",
  gold: "#f2b533",
};

/** GoodLeap marks — shared cap; RoofHub center mark is slightly taller */
const STRIP_LOGO_BAND_SIDE_PX = 52;
const STRIP_LOGO_BAND_CENTER_PX = 66;

const stripLogoImg = {
  display: "block",
  maxHeight: "100%",
  maxWidth: "100%",
  width: "auto",
  height: "auto",
  objectFit: "contain",
  margin: "0 auto",
};

function StripLogoBand({ bandHeight = STRIP_LOGO_BAND_SIDE_PX, children }) {
  return (
    <Box
      sx={{
        height: `${bandHeight}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}

/**
 * Horizontal GoodLeap Plus → RoofHub → GoodLeap strip (dark plate, white marks)
 * — matches partner-flow reference under the hub diagram.
 */
export function RoofHubPartnerFlowStrip() {
  const arrow = (
    <Text
      sx={{
        color: "#fff",
        fontSize: ["1.15rem", "1.35rem"],
        lineHeight: 1,
        px: 1,
        flexShrink: 0,
        fontWeight: 300,
      }}
      aria-hidden
    >
      →
    </Text>
  );

  const col = (children) => (
    <Box
      sx={{
        textAlign: "center",
        flex: ["1 1 auto", "1 1 0"],
        minWidth: 0,
        maxWidth: ["100%", "280px"],
      }}
    >
      {children}
    </Box>
  );

  return (
    <Box
      sx={{
        width: "100%",
        boxSizing: "border-box",
        background: `linear-gradient(165deg, #5a2840 0%, ${rh.maroon} 45%, #5c1a1c 100%)`,
        borderRadius: "8px",
        py: [4, 5],
        px: [2, 4],
        borderTop: `2px solid ${rh.gold}`,
        boxShadow: "0 10px 32px rgba(0,0,0,0.12)",
      }}
    >
      <Flex
        sx={{
          flexDirection: ["column", "row"],
          alignItems: "center",
          justifyContent: "center",
          gap: [3, 2],
          maxWidth: "920px",
          mx: "auto",
        }}
      >
        {col(
          <>
            <Box sx={{ height: "22px", mb: "6px" }} aria-hidden />
            <StripLogoBand>
              <img src={glPlusWhite} alt="GoodLeap Plus" style={stripLogoImg} />
            </StripLogoBand>
            <Text
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontSize: "0.78rem",
                mt: 2,
                lineHeight: 1.5,
                px: 1,
              }}
            >
              Customer clicks to apply from any channel.
            </Text>
          </>
        )}
        <Box sx={{ display: ["none", "block"] }}>{arrow}</Box>
        <Text sx={{ display: ["block", "none"], color: "#fff", fontSize: "1.35rem", lineHeight: 1 }} aria-hidden>
          ↓
        </Text>
        {col(
          <>
            <Box
              sx={{
                height: `${22 - (STRIP_LOGO_BAND_CENTER_PX - STRIP_LOGO_BAND_SIDE_PX)}px`,
                mb: "6px",
              }}
              aria-hidden
            />
            <StripLogoBand bandHeight={STRIP_LOGO_BAND_CENTER_PX}>
              <img src={roofHubLogoWhite} alt="RoofHub" style={stripLogoImg} />
            </StripLogoBand>
            <Text
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontSize: "0.78rem",
                mt: 2,
                lineHeight: 1.5,
                px: 1,
              }}
            >
              Applications and approvals managed in RoofHub.
            </Text>
          </>
        )}
        <Box sx={{ display: ["none", "block"] }}>{arrow}</Box>
        <Text sx={{ display: ["block", "none"], color: "#fff", fontSize: "1.35rem", lineHeight: 1 }} aria-hidden>
          ↓
        </Text>
        {col(
          <>
            <Text
              sx={{
                fontSize: "0.58rem",
                letterSpacing: "0.16em",
                color: "rgba(255,255,255,0.72)",
                fontWeight: 800,
                mb: "6px",
              }}
            >
              POWERED BY
            </Text>
            <StripLogoBand>
              <img src={goodLeapWordmarkWhite} alt="GoodLeap" style={stripLogoImg} />
            </StripLogoBand>
            <Text
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontSize: "0.78rem",
                mt: 2,
                lineHeight: 1.5,
                px: 1,
              }}
            >
              Financing decisions powered by GoodLeap.
            </Text>
          </>
        )}
      </Flex>
    </Box>
  );
}
